export default {
  CREATING: 'MARKETS_VIEW_MARKET_PANEL_CONTRACT_CREATOR_CREATING',
  CREATED: 'MARKETS_VIEW_MARKET_PANEL_CONTRACT_CREATOR_CREATED',
};
